<!-- 申领电子健康卡 -->
<template>
  <div class="applyHealthCard">
    <div class="warning">{{ warningTips }}</div>
    <van-form ref="validateForm" @submit="onSubmit">
      <van-field v-model="form.patientName" label="姓名" placeholder="请输入姓名" :rules="[{ required: true }]" />

      <van-field
        v-model="form.IDCard"
        type="text"
        label="身份证"
        placeholder="请输入身份证号"
        :rules="[{ required: true }, { validator, message: '身份证号码格式错误！' }]"
      >
        <template #button>
          <span style="color: #1ab869; font-size: 4.3vw" @click="qucikInput">快速输入</span>
        </template>
      </van-field>

      <van-field
        v-model="form.tel"
        type="tel"
        label="手机号码"
        placeholder="请输入手机号码"
        :rules="[{ required: true }, { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }]"
      />

      <van-field v-model="form.address" label="地址" placeholder="请输入地址" />

      <van-field v-model="form.maritalStatus" label="婚姻状况" placeholder="请选择婚姻状况" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="maritalStatusList" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>

      <van-field v-model="form.nationality" label="国籍" placeholder="请选择国籍" @click="showNationalityPicker = true" />
      <van-popup v-model="showNationalityPicker" position="bottom">
        <van-picker show-toolbar :columns="countries" @confirm="onNationalityConfirm" @cancel="showNationalityPicker = false" />
      </van-popup>

      <div class="hospitalCardSelecter">
        <van-field name="radio" label="院内就诊卡">
          <template #input>
            <van-radio-group v-model="form.isHospitalCard" direction="horizontal">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <template v-if="form.isHospitalCard === '1'">
          <van-field
            v-model="form.hospitalCard"
            label=" "
            placeholder="请输入院内就诊卡号码"
            :rules="[{ required: true, message: '请输入院内就诊卡号码' }]"
          />
        </template>
      </div>

      <div style="margin: 7.5vw">
        <van-button block type="primary" native-type="submit">立即绑定</van-button>
        <div style="margin: 3.7vh auto; text-align: center; color: #1ab869" @click="qucikInput">一键授权，已有健康卡用户直接绑定></div>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: 'ApplyHealthCard',
  data() {
    return {
      showPicker: false, // 显示婚姻状况选择器
      showNationalityPicker: false, // 显示国籍选择器
      maritalStatusList: ['已婚', '未婚', '其他'], // 婚姻状况选项
      countries: [
        '阿富汗',
        '阿尔巴尼亚',
        '阿尔及利亚',
        '安道尔',
        '安哥拉',
        '安提瓜和巴布达',
        '阿根廷',
        '亚美尼亚',
        '澳大利亚',
        '奥地利',
        '阿塞拜疆',
        '巴哈马',
        '巴林',
        '孟加拉国',
        '巴巴多斯',
        '白俄罗斯',
        '比利时',
        '伯利兹',
        '贝宁',
        '不丹',
        '玻利维亚',
        '波斯尼亚和黑塞哥维那',
        '博茨瓦纳',
        '巴西',
        '文莱',
        '保加利亚',
        '布基纳法索',
        '布隆迪',
        '佛得角',
        '柬埔寨',
        '喀麦隆',
        '加拿大',
        '中非共和国',
        '乍得',
        '智利',
        '中国',
        '哥伦比亚',
        '科摩罗',
        '刚果（布）',
        '刚果（金）',
        '哥斯达黎加',
        '科特迪瓦',
        '克罗地亚',
        '古巴',
        '塞浦路斯',
        '捷克',
        '丹麦',
        '吉布提',
        '多米尼克',
        '多米尼加共和国',
        '东帝汶',
        '厄瓜多尔',
        '埃及',
        '萨尔瓦多',
        '赤道几内亚',
        '厄立特里亚',
        '爱沙尼亚',
        '埃斯瓦蒂尼',
        '埃塞俄比亚',
        '斐济',
        '芬兰',
        '法国',
        '加蓬',
        '冈比亚',
        '格鲁吉亚',
        '德国',
        '加纳',
        '希腊',
        '格林纳达',
        '危地马拉',
        '几内亚',
        '几内亚比绍',
        '圭亚那',
        '海地',
        '洪都拉斯',
        '匈牙利',
        '冰岛',
        '印度',
        '印度尼西亚',
        '伊朗',
        '伊拉克',
        '爱尔兰',
        '以色列',
        '意大利',
        '牙买加',
        '日本',
        '约旦',
        '哈萨克斯坦',
        '肯尼亚',
        '基里巴斯',
        '韩国',
        '科威特',
        '吉尔吉斯斯坦',
        '老挝',
        '拉脱维亚',
        '黎巴嫩',
        '莱索托',
        '利比里亚',
        '利比亚',
        '列支敦士登',
        '立陶宛',
        '卢森堡',
        '马达加斯加',
        '马拉维',
        '马来西亚',
        '马尔代夫',
        '马里',
        '马耳他',
        '马绍尔群岛',
        '毛里塔尼亚',
        '毛里求斯',
        '墨西哥',
        '密克罗尼西亚',
        '摩尔多瓦',
        '摩纳哥',
        '蒙古',
        '黑山',
        '摩洛哥',
        '莫桑比克',
        '缅甸',
        '纳米比亚',
        '瑙鲁',
        '尼泊尔',
        '荷兰',
        '新西兰',
        '尼加拉瓜',
        '尼日尔',
        '尼日利亚',
        '北马其顿',
        '挪威',
        '阿曼',
        '巴基斯坦',
        '帕劳',
        '巴勒斯坦',
        '巴拿马',
        '巴布亚新几内亚',
        '巴拉圭',
        '秘鲁',
        '菲律宾',
        '波兰',
        '葡萄牙',
        '卡塔尔',
        '罗马尼亚',
        '俄罗斯',
        '卢旺达',
        '圣基茨和尼维斯',
        '圣卢西亚',
        '圣文森特和格林纳丁斯',
        '萨摩亚',
        '圣马力诺',
        '圣多美和普林西比',
        '沙特阿拉伯',
        '塞内加尔',
        '塞尔维亚',
        '塞舌尔',
        '塞拉利昂',
        '新加坡',
        '斯洛伐克',
        '斯洛文尼亚',
        '所罗门群岛',
        '索马里',
        '南非',
        '南苏丹',
        '西班牙',
        '斯里兰卡',
        '苏丹',
        '苏里南',
        '瑞典',
        '瑞士',
        '叙利亚',
        '塔吉克斯坦',
        '坦桑尼亚',
        '泰国',
        '多哥',
        '汤加',
        '特立尼达和多巴哥',
        '突尼斯',
        '土耳其',
        '土库曼斯坦',
        '图瓦卢',
        '乌干达',
        '乌克兰',
        '阿联酋',
        '英国',
        '美国',
        '乌拉圭',
        '乌兹别克斯坦',
        '瓦努阿图',
        '梵蒂冈',
        '委内瑞拉',
        '越南',
        '也门',
        '赞比亚',
        '津巴布韦'
      ], // 国籍选项
      form: {
        patientName: '', // 姓名
        IDCard: '', // 身份证号
        tel: '', // 手机号
        address: '', // 地址
        maritalStatus: '', // 婚姻状况
        nationality: '', // 国籍
        isHospitalCard: '0', // 是否有院内就诊卡
        hospitalCard: '' // 院内就诊卡
      },
      warningTips: '本院实行实名制就诊，请如实填写就诊人信息，如因信息错误产生的一切后果自行负责。'
    };
  },
  created() {
    this.warningTips = window.sys.honeyTips.addClient[0];
  },
  methods: {
    /**
     * 身份证验证
     */
    validator(val) {
      const card15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
      const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return card15.test(val) || card18.test(val);
    },
    // 确认选择婚姻状况
    onConfirm(value) {
      this.form.maritalStatus = value;
      this.showPicker = false;
    },
    // 确认选择国籍
    onNationalityConfirm(value) {
      this.form.nationality = value;
      this.showNationalityPicker = false;
    },

    // 点击立即绑定
    async onSubmit() {},

    // 根据身份证获取出生日期
    getBirthDateFromIdCard(idCard) {
      if (!idCard || idCard.length !== 18) {
        return null; // 身份证号无效
      }

      const birthDateStr = idCard.substring(6, 14); // 提取出生日期部分
      const year = birthDateStr.substring(0, 4);
      const month = birthDateStr.substring(4, 6);
      const day = birthDateStr.substring(6, 8);

      return `${year}-${month}-${day}`; // 返回格式化的出生日期
    },

    // 点击快速输入跳转到绑定已有就诊卡界面
    qucikInput() {}
  }
};
</script>

<style lang="scss" scoped>
.applyHealthCard {
  width: 100vw;
  height: 100vh;
  background: #f9f9f9;
  .warning {
    width: 100vw;
    height: 7.5vh;
    background: #fff6ed;
    font-size: 3.7vw;
    padding: 2.7vw;
    box-sizing: border-box;
    color: #ee9818;
  }
  .hospitalCardSelecter {
    margin-top: 0.6vh;
    ::v-deep .van-radio__icon--checked .van-icon {
      color: #fff;
      background-color: #01cc88;
      border-color: #01cc88;
    }
  }
}
</style>
